@use 'sass:map';
@use 'sass:list';

@import '../../global/style/utilities/globals';
@import '../../global/style/nano-theme/form';
@import '../../global/style/nano-theme/base';
@import '../../global/style/nano-theme/layers';

:host {
  /**
  * @prop --padding-top: for all nested `nano-option` elements. Defaults to #{$spacing-small};
  * @prop --padding-bottom: for all nested `nano-option` elements. Defaults to #{$spacing-small};
  * @prop --padding-start: for all nested `nano-option` elements. Defaults to #{$spacing-xlarge};
  * @prop --padding-end: for all nested `nano-option` elements. Defaults to #{$spacing-xlarge};
  * @prop --font-size: for all nested `nano-option` elements. Defaults to .8em;
  * @prop --color: default text color of content other than `nano-option`. Defaults to #{map.get($colors, palegrey)};
  */

  --padding-top: #{$spacing-small};
  --padding-bottom: #{$spacing-small};
  --padding-start: #{$spacing-xlarge};
  --padding-end: #{$spacing-xlarge};
  --font-size: 0.8em;
  --color: #{map.get($colors, palegrey)};

  color: var(--color);
}

.dlist {
  &--isfiltered {
    ::slotted(*:not(nano-option):not([slot='no-result']):not([slot='list-top']):not([slot='list-bottom'])) {
      display: none !important;
    }
  }

  &__dropdown {
    --min-width: 100%;
    --overflow: auto;
  }

  &__status {
    @include visually-hide();
  }

  &__menu {
    --padding-top: inherit;
    --padding-bottom: inherit;
    --padding-start: inherit;
    --padding-end: inherit;
    --font-size: inherit;
  }
}
